import { ChevronRight } from 'lucide-react'
import { Body, Button, ButtonVariant, ButtonStyle } from '@meiuca/ui-components'
import { Arena } from '../types/arena'
import { ArenaCard } from './ArenaCard'

interface ArenaSectionProps {
  title: string
  arenas: Arena[]
  onSeeMore?: () => void
  onArenaClick?: (arena: Arena) => void
}

export function ArenaSection({ title, arenas, onSeeMore, onArenaClick }: ArenaSectionProps) {
  if (arenas.length === 0) return null

  return (
    <section className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Body className="text-text-primary font-semibold">{title}</Body>
        {onSeeMore && (
          <Button
            variant={ButtonVariant.SECONDARY}
            buttonStyle={ButtonStyle.CLEAR}
            size="sm"
            onClick={onSeeMore}
            className="flex items-center gap-1"
          >
            Ver mais
            <ChevronRight className="w-4 h-4" />
          </Button>
        )}
      </div>

      {/* Lista horizontal de arenas */}
      <div className="overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0 scrollbar-hide">
        <div className="flex gap-4">
          {arenas.map((arena) => (
            <ArenaCard
              key={arena.id}
              arena={arena}
              onClick={() => onArenaClick?.(arena)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
